import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi/poi-base.js';
      import {ObcPoiType, ObcPoiValue, ObcPoiState} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi/poi.js';
import {ObcPoiButtonType, ObcPoiButtonDataItem} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-button/poi-button.js';
import {ObcPoiPointerType, ObcPoiPointerState} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-pointer/poi-pointer.js';

      export interface Props {
     type?: ObcPoiType;
     value?: ObcPoiValue;
     state?: ObcPoiState;
     selected?: boolean;
     buttonType?: ObcPoiButtonType;
     overlapOpaque?: boolean;
     data?: ObcPoiButtonDataItem[];
     hasHeader?: boolean;
     headerContent?: string;
     hasPointer?: boolean;
     pointerType?: ObcPoiPointerType | null;
     pointerState?: ObcPoiPointerState | null;
     relativeDirection?: number;
     x?: number;
     y?: number;
     buttonY?: number | null;
     fixedTarget?: boolean;
     buttonOffsetX?: number;
     targetOffsetX?: number;
     boxWidth?: number | null;
     boxHeight?: number | null;
     lineCompensationY?: number;
     outsideAngle?: number;
     animatePosition?: boolean
   }

      
  
      export type {ObcPoiType, ObcPoiValue, ObcPoiState} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi/poi.js';
export type {ObcPoiButtonType, ObcPoiButtonDataItem} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-button/poi-button.js';
export type {ObcPoiPointerType, ObcPoiPointerState} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-pointer/poi-pointer.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPoiBase',
  props: {
    type: {},
    value: {},
    state: {},
    selected: { type: Boolean },
    buttonType: {},
    overlapOpaque: { type: Boolean },
    data: {},
    hasHeader: { type: Boolean },
    headerContent: {},
    hasPointer: { type: Boolean },
    pointerType: {},
    pointerState: {},
    relativeDirection: {},
    x: {},
    y: {},
    buttonY: {},
    fixedTarget: { type: Boolean },
    buttonOffsetX: {},
    targetOffsetX: {},
    boxWidth: {},
    boxHeight: {},
    lineCompensationY: {},
    outsideAngle: {},
    animatePosition: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'undefined',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})